<script>
  import {modalState, hideModal} from '@app/store/modalStore.svelte.js';
  import {environment} from '@app/store/envStore.svelte.js';
  import {authState} from '@app/store/authStore.svelte.js';
  import * as m from '@app/paraglide/messages.js';

  async function openDevTools(){
    if (environment.electron){
      await window.ipcRenderer.invoke("openDevTools");
    }
  }
</script>

<div class="modal fade {modalState.selected === 'about' ? 'show d-block' : ''}" role="dialog" tabindex="-1" id="AboutModal" aria-labelledby="aboutTitle" aria-describedby="aboutDesc">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="aboutTitle" class="modal-title">{m.about()}</h4>
        <button type="button" class="btn-close" aria-label={m.close()} onclick={hideModal} id="closeAbout"></button>
      </div>
      <div class="modal-body" id="aboutDesc">
        <p>{m.ccc_version({ version: environment.version })}</p>
        <div class="row">
          <div class="col-4 d-xl-flex justify-content-xl-center align-items-xl-center">
             <!-- svelte-ignore a11y_click_events_have_key_events -->
             <!-- svelte-ignore a11y_no_noninteractive_element_interactions -->
             <img class="img-fluid" src="./assets/img/icon.png" style="width: 105px;" alt={m.ccc_logo_alt()} onclick={() => openDevTools()} id="aboutLogo"></div>
          <div class="col">
            <h5>{m.contact_information()}</h5>
            <p>support@closedcaptioncreator.com<br>www.closedcaptioncreator.com</p>
            
            <h6>{m.user_label({ user: authState.user ? authState.user.email ?? m.offline() : '' })}</h6>
            <h6>{m.license_type({ type: authState.plan })}</h6>
            <h6>{m.license_status({ status: authState.status })}</h6>
            {#if authState.ad}
                <h6 class="mb-2">{m.plugins_audio_description()}</h6>
            {/if}
          </div>
        </div>
      </div>
      <div class="modal-footer d-xl-flex justify-content-xl-center">
        <p class="text-center small">{m.ccc_copyright()}</p>
      </div>
    </div>
  </div>
</div>
